<template></template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const { mapActions } = createNamespacedHelpers('conference')

  export default {
    props: [
      'channel'
    ],
    created () {
      this.channel.bind('message.created', this.addPrivateMessage)
    },
    methods: mapActions([
      'addPrivateMessage'
    ])
  }
</script>



// WEBPACK FOOTER //
// message-created.vue?83002958